import { useContext } from 'react';
import { PaymentOverdueModalContext } from './paymentOverdueModalContext';

export function usePaymentOverdueModal() {
  return useContext(PaymentOverdueModalContext);
}
